import { gql } from '@apollo/client'

export const GET_USER_ROLES = gql`
  query {
    getUserRoles {
      code
    }
  }
`
